export default __webpack_public_path__ + "static/media/close-icon.b765a098.svg";